








var jspb=require('google-protobuf');
var goog=jspb;
var global=Function('return this')();

goog.exportSymbol('proto.mti.store.secure_plug.SecurePlugPortStatus',null,global);











proto.mti.store.secure_plug.SecurePlugPortStatus=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,null);
};
goog.inherits(proto.mti.store.secure_plug.SecurePlugPortStatus,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.store.secure_plug.SecurePlugPortStatus.displayName='proto.mti.store.secure_plug.SecurePlugPortStatus';
}


if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.toObject=function(opt_includeInstance){
return proto.mti.store.secure_plug.SecurePlugPortStatus.toObject(opt_includeInstance,this);
};











proto.mti.store.secure_plug.SecurePlugPortStatus.toObject=function(includeInstance,msg){
var f,obj={
devicePluggedIn:jspb.Message.getFieldWithDefault(msg,1,false),
calibrated:jspb.Message.getFieldWithDefault(msg,2,false),
calibrationFailed:jspb.Message.getFieldWithDefault(msg,3,false),
socketFault:jspb.Message.getFieldWithDefault(msg,4,false),
socketDeviceType:jspb.Message.getFieldWithDefault(msg,5,0)};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.store.secure_plug.SecurePlugPortStatus.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.store.secure_plug.SecurePlugPortStatus();
return proto.mti.store.secure_plug.SecurePlugPortStatus.deserializeBinaryFromReader(msg,reader);
};









proto.mti.store.secure_plug.SecurePlugPortStatus.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=reader.readBool();
msg.setDevicePluggedIn(value);
break;
case 2:
var value=reader.readBool();
msg.setCalibrated(value);
break;
case 3:
var value=reader.readBool();
msg.setCalibrationFailed(value);
break;
case 4:
var value=reader.readBool();
msg.setSocketFault(value);
break;
case 5:
var value=reader.readUint32();
msg.setSocketDeviceType(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.store.secure_plug.SecurePlugPortStatus.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.store.secure_plug.SecurePlugPortStatus.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getDevicePluggedIn();
if(f){
writer.writeBool(
1,
f);

}
f=message.getCalibrated();
if(f){
writer.writeBool(
2,
f);

}
f=message.getCalibrationFailed();
if(f){
writer.writeBool(
3,
f);

}
f=message.getSocketFault();
if(f){
writer.writeBool(
4,
f);

}
f=message.getSocketDeviceType();
if(f!==0){
writer.writeUint32(
5,
f);

}
};








proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.getDevicePluggedIn=function(){
return jspb.Message.getFieldWithDefault(this,1,false);
};



proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.setDevicePluggedIn=function(value){
jspb.Message.setProto3BooleanField(this,1,value);
};








proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.getCalibrated=function(){
return jspb.Message.getFieldWithDefault(this,2,false);
};



proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.setCalibrated=function(value){
jspb.Message.setProto3BooleanField(this,2,value);
};








proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.getCalibrationFailed=function(){
return jspb.Message.getFieldWithDefault(this,3,false);
};



proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.setCalibrationFailed=function(value){
jspb.Message.setProto3BooleanField(this,3,value);
};








proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.getSocketFault=function(){
return jspb.Message.getFieldWithDefault(this,4,false);
};



proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.setSocketFault=function(value){
jspb.Message.setProto3BooleanField(this,4,value);
};






proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.getSocketDeviceType=function(){
return jspb.Message.getFieldWithDefault(this,5,0);
};



proto.mti.store.secure_plug.SecurePlugPortStatus.prototype.setSocketDeviceType=function(value){
jspb.Message.setProto3IntField(this,5,value);
};


goog.object.extend(exports,proto.mti.store.secure_plug);